<app-toolbar (eventOpenSidnav)="openCloseSidenav($event)"></app-toolbar>
<app-sidenav [openedSidenav]="(openedSidenav$ | async) || false"></app-sidenav>